var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"allow":"clipboard-read; clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }